import { stopTracking } from "./tracking";

async function logoutUser(){
    stopTracking();
    localStorage.removeItem('authToken');
    localStorage.removeItem('idThread');
}

export { logoutUser };